class PreviewLaunch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)

    this.handleOnLoadTrigger()
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-preview-launch-external-el="trigger"]',
    )
    if (!trigger) return

    await window.BAO.sectionRenderer
      .fetchSingle('preview-launch', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        this.els.content.element.innerHTML = myself.innerHTML
      })
      .catch(() => {})
  }

  handleOnLoadTrigger (event) {
    if (
      document.body.classList.contains('util-pdp-open-preview-launch-modal')
    ) {
      document.querySelector('[data-drawers-trigger="preview-launch"]').click()

      // Select the entire document body to observe
      const targetNode = document.body

      // Options for the observer (we're tracking changes to child nodes and subtree)
      const observerOptions = {
        childList: true, // Watch for the addition/removal of child nodes
        subtree: true, // Watch changes to all descendant elements
      }

      // Callback function to handle the mutation events
      const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                if (
                  node.classList &&
                  node.classList.contains('prd-BackInStock_Product')
                ) {
                  document
                    .querySelector('[data-product-add-to-cart]')
                    .setAttribute('aria-hidden', 'true')
                  document
                    .querySelector('[data-product-bis-trigger]')
                    .setAttribute('aria-hidden', 'false')
                }
              }
            })
          }
        }
      }

      const observer = new MutationObserver(callback)

      observer.observe(targetNode, observerOptions)
    }
  }
}

if (!customElements.get('preview-launch')) {
  customElements.define('preview-launch', PreviewLaunch)
}
